import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({ status, type = 'order' }) => {
    const getStatusConfig = () => {
        if (type === 'order') {
            const configs = {
                pending: { label: 'Pending', className: 'status-pending' },
                accepted: { label: 'Accepted', className: 'status-accepted' },
                completed: { label: 'Completed', className: 'status-completed' },
                cancelled: { label: 'Cancelled', className: 'status-cancelled' },
                refunded: { label: 'Refunded', className: 'status-refunded' },
            };
            return configs[status] || { label: status, className: 'status-default' };
        } else if (type === 'payment') {
            const configs = {
                paid: { label: 'Paid', className: 'status-paid' },
                pending: { label: 'Pending', className: 'status-pending' },
                failed: { label: 'Failed', className: 'status-failed' },
            };
            return configs[status] || { label: status, className: 'status-default' };
        } else if (type === 'settlement') {
            const configs = {
                pending: { label: 'Pending', className: 'status-pending' },
                paid: { label: 'Paid', className: 'status-paid' },
                in_review: { label: 'In Review', className: 'status-in-review' },
            };
            return configs[status] || { label: status, className: 'status-default' };
        } else if (type === 'user') {
            const configs = {
                active: { label: 'Active', className: 'status-active' },
                inactive: { label: 'Inactive', className: 'status-inactive' },
            };
            return configs[status] || { label: status, className: 'status-default' };
        }
        return { label: status, className: 'status-default' };
    };

    const config = getStatusConfig();

    return (
        <span className={`status-badge ${config.className}`}>
            {config.label}
        </span>
    );
};

export default StatusBadge;

